class GraphicsLibraryActionType {
    static loadTags = {
        start: 'COMPONENT_GRAPHICS_LIBRARY_LOAD_TAGS_START',
        success: 'COMPONENT_GRAPHICS_LIBRARY_LOAD_TAGS_SUCCESS',
        fail: 'COMPONENT_GRAPHICS_LIBRARY_LOAD_TAGS_FAIL',
        reset: 'COMPONENT_GRAPHICS_LIBRARY_LOAD_TAGS_RESET',
    };

    static loadDesigns = {
        start: 'COMPONENT_GRAPHICS_LIBRARY_LOAD_DESIGNS_START',
        success: 'COMPONENT_GRAPHICS_LIBRARY_LOAD_DESIGNS_SUCCESS',
        fail: 'COMPONENT_GRAPHICS_LIBRARY_LOAD_DESIGNS_FAIL',
        reset: 'COMPONENT_GRAPHICS_LIBRARY_LOAD_DESIGNS_RESET',
    };

    static loadGraphics = {
        start: 'COMPONENT_GRAPHICS_LIBRARY_LOAD_GRAPHICS_START',
        success: 'COMPONENT_GRAPHICS_LIBRARY_LOAD_GRAPHICS_SUCCESS',
        fail: 'COMPONENT_GRAPHICS_LIBRARY_LOAD_GRAPHICS_FAIL',
        reset: 'COMPONENT_GRAPHICS_LIBRARY_LOAD_GRAPHICS_RESET',
    };

    static deleteGraphic = {
        start: 'COMPONENT_GRAPHICS_LIBRARY_DELETE_GRAPHIC_START',
        success: 'COMPONENT_GRAPHICS_LIBRARY_DELETE_GRAPHIC_SUCCESS',
        fail: 'COMPONENT_GRAPHICS_LIBRARY_DELETE_GRAPHIC_FAIL',
        reset: 'COMPONENT_GRAPHICS_LIBRARY_DELETE_GRAPHIC_RESET',
    };

    static graphicsFilter = {
        set: 'COMPONENT_GRAPHICS_LIBRARY_SET_GRAPHICS_FILTER',
        clear: 'COMPONENT_GRAPHICS_LIBRARY_CLEAR_GRAPHICS_FILTER',
    };
}

export default GraphicsLibraryActionType;
